import React from 'react'
export const yfi_circle_color = {
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2.6665C23.3626 2.6665 29.3333 8.63717 29.3333 15.9998C29.3333 23.3625 23.3626 29.3332 16 29.3332C8.63729 29.3332 2.66663 23.3625 2.66663 15.9998C2.66663 8.63717 8.63729 2.6665 16 2.6665Z"
        fill="url(#yfi_paint0_linear)"
        key="KOq04wjac"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6001 14.2239L17.8694 15.2132L17.0374 11.3412L18.1468 11.0905L18.5841 12.9252C18.5841 12.9252 19.5921 11.2719 18.2481 9.55986C17.4776 8.70376 17.1008 8.64518 16.2633 8.51495L16.1921 8.50386C15.4108 8.39186 13.5948 8.65586 13.0534 10.7759C12.8241 12.1412 13.0828 13.1519 14.8428 14.4745L14.7441 15.9465C14.7441 15.9465 12.7788 14.5625 12.2721 13.5919C11.8801 12.8239 11.2081 11.3065 12.4214 9.19453C13.0748 8.13853 14.3628 7.12519 16.6321 7.23186C17.7734 7.27986 20.5601 8.67453 20.1281 11.9332C20.0534 12.5439 19.7361 13.3572 19.7361 13.3572L21.2668 13.0159L21.6001 14.2239ZM15.4505 21.6212V10.5278H16.6585V21.6212H15.4505ZM15.2081 24.7547C17.4721 24.92 18.7868 23.9413 19.4694 22.904C20.7361 20.8267 20.1041 19.2907 19.7361 18.5093C19.2561 17.5253 17.3281 16.0907 17.3281 16.0907L17.1894 17.56C18.9121 18.9307 19.1441 19.9493 18.8801 21.3067C18.2828 23.4107 16.4588 23.6293 15.6828 23.496C15.657 23.4913 15.6316 23.4866 15.6067 23.4821C14.7727 23.33 14.3991 23.2618 13.6534 22.3867C12.3574 20.6373 13.4081 19.0133 13.4081 19.0133L13.7974 20.8613L14.9148 20.64L14.1841 16.7467L10.4268 17.6373L10.7281 18.8507L12.2668 18.552C12.2668 18.552 11.9281 19.3547 11.8374 19.9627C11.3201 23.208 14.0668 24.6773 15.2081 24.7547Z"
        fill="white"
        key="jPi3mEahf1"
      />
      <linearGradient
        id="yfi_paint0_linear"
        key="yfi_paint0_linear"
        x1="8.50549"
        y1="6.49985"
        x2="24.0055"
        y2="28.9998"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0060CD" key="FXwnkbE1u4" />
        <stop offset="1" stopColor="#6AADFA" key="lUmoUgjOJj" />
      </linearGradient>
    </>
  ),
  viewBox: '0 0 32 32',
}
